import type { RefObject } from 'react';

const focusRing = 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-blue';

/** Sticky page header for views with no dashboard filters (e.g. Settings) — same frame as FilterBar. */
export function PageHeader({
  title,
  subtitle,
  onOpenMenu,
  menuButtonRef,
}: {
  title: string;
  subtitle?: string;
  onOpenMenu: () => void;
  menuButtonRef: RefObject<HTMLButtonElement>;
}) {
  return (
    <header className="sticky top-0 z-20 flex min-h-[72px] flex-col justify-center border-b border-border bg-surface/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1400px] items-center gap-4 px-4 py-3 sm:px-8">
        <button
          ref={menuButtonRef}
          type="button"
          onClick={onOpenMenu}
          aria-label="Open navigation"
          className={`-ml-2 flex h-11 w-11 items-center justify-center rounded-input text-text-muted hover:text-text-default lg:hidden ${focusRing}`}
        >
          <i aria-hidden="true" className="fa-solid fa-bars text-lg" />
        </button>
        <div className="min-w-0">
          <h1 className="text-[19px] font-bold text-text-default">{title}</h1>
          {subtitle && <p className="text-xs text-text-faint">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
}
